import { Transaction } from "@/types/transaction-type";

type FeeSource = Pick<
  Transaction,
  "type" | "amount" | "fee_pct" | "fee" | "base_asset" | "quote_asset"
>;

/** Сумма комиссии в валюте операции; для exchange — в quote_asset (как колонка amount). */
export function formatTransactionFeeDisplay(row: FeeSource): string {
  const type = row.type?.toLowerCase();
  const pct = Number(row.fee_pct) || 0;
  const amountNum = Number(row.amount) || 0;
  const fromApi = row.fee;
  const absFee =
    fromApi != null && !Number.isNaN(Number(fromApi))
      ? Number(fromApi)
      : (amountNum * pct) / 100;
  const asset =
    type === "exchange" ? row.quote_asset || "" : row.base_asset || "";
  const formatted = parseFloat(absFee.toFixed(8)).toString();
  if (pct === 0 && absFee === 0) return "—";
  const pctPart = pct > 0 ? ` (${pct}%)` : "";
  return asset ? `${formatted} ${asset}${pctPart}` : `${formatted}${pctPart}`;
}
